// extracted by mini-css-extract-plugin
export default {"eventBody":"Organism_eventBody__t+6bB","from":"Organism_from__oGVTT","to":"Organism_to__fqMW9"};